import { render, staticRenderFns } from "./Top10JWTVModule.vue?vue&type=template&id=6a5d3422&scoped=true"
import script from "./Top10JWTVModule.vue?vue&type=script&lang=ts&setup=true"
export * from "./Top10JWTVModule.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Top10JWTVModule.vue?vue&type=style&index=0&id=6a5d3422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d3422",
  null
  
)

export default component.exports